"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @export
 * @class Adal4User
 */
var Adal4User = (function () {
    function Adal4User() {
    }
    return Adal4User;
}());
exports.Adal4User = Adal4User;



//////////////////
// WEBPACK FOOTER
// ./~/adal-angular4/adal4-user.js
// module id = 371
// module chunks = 1